module.exports = __webpack_public_path__ + "img/i_phone8_overlay.65eeec5a.svg";